<mat-checkbox
  class="cellcheckbox custom-mat-checkbox"
  [checked]="checked"
  color="warn"
  (change)="headerCheckChanged($event)"
></mat-checkbox>
